import { render, staticRenderFns } from "./SectionsPanel.vue?vue&type=template&id=535fb3e8"
import script from "./SectionsPanel.vue?vue&type=script&lang=js"
export * from "./SectionsPanel.vue?vue&type=script&lang=js"
import style0 from "./SectionsPanel.vue?vue&type=style&index=0&id=535fb3e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports